module.exports = __webpack_public_path__ + "static/media/furniture-tc.a12702c6.svg";